import React from 'react';
import SharedHelpIcon from 'Utils/HelpIcon';

/**
 * A section heading whose explanation sits behind an info icon instead of a line of text under the
 * title. `help` is also the icon's aria-label, so tests and screen readers can read it without hovering.
 */
// The shared, focusable info button (Utils/HelpIcon); re-exported so TDM imports keep working.
export const HelpIcon = (props) => <SharedHelpIcon placement='right' className='tdm-help' {...props} />;

/** `action` (a button, say) sits at the right-hand end of the heading row. */
const SectionTitle = ({ title, help, testId, className, action }) => (
  <h2 className={`tdm-section__title${help || action ? ' tdm-section__title--row' : ''}${className ? ` ${className}` : ''}`}>
    <span>{title}</span>
    {help && <HelpIcon help={help} testId={testId} />}
    {action && <span className='tdm-section__title-action'>{action}</span>}
  </h2>
);

export default SectionTitle;
